import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { all as getAdSubscriptions } from '../../../actions/ad-subscription';
import { history } from '../../../actions/history';
import SearchBody from '../../../components/search/search-body';
import type QueryFilter from '../../../helpers/query-filter';
import { isAuthenticated } from '../../../selectors/auth';
import { getQueryFilter } from '../../../utils/reselectors';
import SearchLinkCloud from '../components/search-link-cloud';
import ListHero from './list-hero';
const BASE_SEARCH_PATH = '/sok';

interface SearchProps {
  target?: string;
}

const Search = ({ target }: SearchProps) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const authenticated = useSelector(isAuthenticated);
  const qf = useSelector(getQueryFilter);

  const actions = bindActionCreators(
    {
      history,
      getAdSubscriptions,
    },
    dispatch,
  );

  useEffect(() => {
    if (authenticated) {
      actions.getAdSubscriptions();
    }
  }, [authenticated]);

  const onNavigate = (queryFilter: QueryFilter) => {
    if (!qf.isSame(queryFilter, false)) {
      const list = new URLSearchParams(location.search).get('list');
      const addQuestion = queryFilter.toQueryURL().indexOf('?') === -1;
      const listQuery = list ? `${addQuestion ? '?' : '&'}list=${list}` : '';
      navigate(`${target || BASE_SEARCH_PATH}${queryFilter.toQueryURL()}${listQuery}`);
    }
  };

  return (
    <>
      <ListHero />
      <div className="m-t hidden-lt-md" />
      <div data-wx-page="relative-top-thin" className="container" aria-label="Sök">
        <SearchBody navigate={onNavigate} target="/sok" />
      </div>
      <SearchLinkCloud />
    </>
  );
};

export default Search;
